
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M24 0H0v16h24V0z","fill":"#6DA544"}}),_c('path',{attrs:{"d":"M12 3.579l6 4.42-6 4.422L6 8l6-4.421z","fill":"#FFDA44"}}),_c('path',{attrs:{"d":"M12 10.526a2.526 2.526 0 100-5.052 2.526 2.526 0 000 5.052z","fill":"#F0F0F0"}}),_c('path',{attrs:{"d":"M10.737 7.842c-.44 0-.863.067-1.262.19a2.526 2.526 0 004.594 1.417 4.257 4.257 0 00-3.332-1.607zM14.48 8.484a2.526 2.526 0 00-4.801-1.481 5.196 5.196 0 014.801 1.481z","fill":"#0052B4"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 1a1 1 0 011-1h22a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1z","fill":"#fff"}})])])])
          )
        }
      }
    